(function(){
  function init(){
    var H=document.getElementById('pth');if(!H)return;
    var W=H.closest('.shopify-section')||H.parentElement;W.classList.add('pth-wrap');
    document.body.style.paddingTop='0px';
    var last=0,tick=false;
    function getY(e){
      var y=window.pageYOffset||((document.scrollingElement&&document.scrollingElement.scrollTop)||0);
      if(e&&e.target&&e.target!==document&&e.target!==window&&typeof e.target.scrollTop==='number'&&e.target.scrollTop>y){y=e.target.scrollTop;}
      return y;
    }
    function onScroll(e){
      if(tick)return;tick=true;
      requestAnimationFrame(function(){
        var y=getY(e);
        H.classList.toggle('sc',y>12);
        if(y>last+2&&y>280&&!document.body.classList.contains('pth-drawer')){W.classList.add('hide');}
        else if(y<last-2||y<=280){W.classList.remove('hide');}
        last=y;tick=false;
      });
    }
    document.addEventListener('scroll',onScroll,{capture:true,passive:true});
    var ms=[].slice.call(document.querySelectorAll('#pth-msg span')),mi=0;
    if(ms.length>1){setInterval(function(){ms[mi].classList.remove('on');mi=(mi+1)%ms.length;ms[mi].classList.add('on');},3600);}
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){var b=document.getElementById('pth-bub');if(b&&c.item_count>0){b.textContent=c.item_count;b.style.display='flex';}}).catch(function(){});
    /* search overlay + live results */
    var so=document.getElementById('pth-so'),q=document.getElementById('pth-q'),res=document.getElementById('pth-res'),pop=document.getElementById('pth-pop');
    function soOpen(){so.classList.add('open');setTimeout(function(){if(q)q.focus();},60);}
    function soClose(){so.classList.remove('open');}
    var sbtn=document.getElementById('pth-search');
    if(sbtn&&so){sbtn.addEventListener('click',soOpen);
      document.getElementById('pth-soclose').addEventListener('click',soClose);}
    document.addEventListener('keydown',function(e){
      if((e.metaKey||e.ctrlKey)&&(e.key==='k'||e.key==='K')){e.preventDefault();if(so.classList.contains('open')){soClose();}else{soOpen();}}
    });
    var deb=null;
    function esc(s){var d=document.createElement('div');d.textContent=s;return d.innerHTML;}
    function render(list,term){
      if(!list.length){res.innerHTML='<div style="padding:14px 8px;color:#615c93;font-size:14px;">Nothing found for “'+esc(term)+'” — try another word?</div>';pop.style.display='';return;}
      pop.style.display='none';
      res.innerHTML=list.map(function(p){
        var img=p.image?('<img src="'+p.image+'&width=96" alt="">').replace('&width','?width'):'';
        if(p.image&&p.image.indexOf('?')>-1){img='<img src="'+p.image+'&width=96" alt="">';}else if(p.image){img='<img src="'+p.image+'?width=96" alt="">';}
        var price=p.price?('£'+p.price):'';
        return '<a class="pth__ri" href="'+p.url+'"><span class="im">'+img+'</span><b>'+esc(p.title)+'</b><span>'+price+'</span></a>';
      }).join('')+'<a class="pth__rall" href="/search?q='+encodeURIComponent(term)+'">See all results for “'+esc(term)+'” →</a>';
    }
    if(q){q.addEventListener('input',function(){
      var term=q.value.trim();
      clearTimeout(deb);
      if(term.length<2){res.innerHTML='';pop.style.display='';return;}
      deb=setTimeout(function(){
        fetch('/search/suggest.json?q='+encodeURIComponent(term)+'&resources[type]=product&resources[limit]=6')
          .then(function(r){return r.json();})
          .then(function(d){var ps=(((d||{}).resources||{}).results||{}).products||[];render(ps,term);})
          .catch(function(){});
      },220);
    });}
    /* drawer */
    var bg=document.getElementById('pth-burger');
    if(bg){bg.addEventListener('click',function(){document.body.classList.add('pth-drawer');});
      document.getElementById('pth-drclose').addEventListener('click',function(){document.body.classList.remove('pth-drawer');});
      document.getElementById('pth-ov').addEventListener('click',function(){document.body.classList.remove('pth-drawer');});}
    document.addEventListener('keydown',function(e){if(e.key==='Escape'){soClose();document.body.classList.remove('pth-drawer');}});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
